/** Exclusive: the announcement shows through the end of October 13, 2026 Mountain. */
export const CATALOG_NAV_ANNOUNCEMENT_CUTOFF = Temporal.ZonedDateTime.from(
  "2026-10-14T00:00:00[America/Denver]",
).toInstant();

export function shouldShowCatalogNavAnnouncement({
  canAccessCatalog,
  catalogBaseUrl,
  dismissed,
  inventoryBaseUrl,
  isPreview,
  isRedoEmail,
  now,
  pathname,
}: {
  /** Without it there is no Catalog nav item to point at, even in preview. */
  canAccessCatalog: boolean;
  catalogBaseUrl: string;
  dismissed: boolean;
  inventoryBaseUrl: string;
  isPreview: boolean;
  isRedoEmail: boolean;
  now: Temporal.Instant;
  pathname: string;
}): boolean {
  if (dismissed || !canAccessCatalog) {
    return false;
  }
  if (isPreview) {
    return true;
  }
  return (
    Temporal.Instant.compare(now, CATALOG_NAV_ANNOUNCEMENT_CUTOFF) < 0 &&
    !isRedoEmail &&
    (pathname.startsWith(inventoryBaseUrl) ||
      pathname.startsWith(catalogBaseUrl))
  );
}
